const miniMenusOverflow = header.find('.mini-menus-overflow');

const cartCloseBG = header.find('.menus-close-bg');
const cartOverflow = header.find('.cart-overflow');
const cartMenu = cartOverflow.find('.cart-menu');
const cartLines = cartMenu.find('.cart-menu-line');
const cartCloseBtn = cartMenu.find('.cart-menu-close-icon');
const checkoutBtn = cartMenu.find('.button-parent');
const cartNavButtons = header.find('.nav-item-link[href$="#cart"]');
let cartTL;

const addCartNavCounter = () => {
  cartNavButtons.each(function (index) {
    if (index == 0) {
      const cartButtonParent = $(this).closest('.nav-item');
      const cartButtonHover = cartButtonParent.find('.nav-item-link-text-hover');
      const cartCounterParent = $('<span>', { class: 'nav-item-cart-counter-parent' });
      const cartCounterBorder = $('<span>', { class: 'nav-item-cart-counter-border' });
      const cartCounter = $('<span>', { class: 'nav-item-cart-counter', text: '0' });
      cartCounterBorder.append(cartCounter);
      cartCounterParent.append(cartCounterBorder);
      $(this).append(cartCounterParent.clone());
      cartButtonHover.append(cartCounterParent);
    }
  });
};

const setCartNavCounter = (count) => {
  cartNavButtons.each(function (index) {
    if (index == 0) {
      const cartCounterParent = $('.nav-item-cart-counter-parent');
      const cartCounterBorder = $('.nav-item-cart-counter-border');
      const cartCounter = $('.nav-item-cart-counter');
      const parentPadding = pxToVw(Number(cartCounterParent.css('padding-inline').replace('px', '')));
      cartCounter.text(count);

      const cartCounterWidth = pxToVw(cartCounter.outerWidth());
      gsap.set(cartCounterBorder, { width: `${cartCounterWidth}vw` });
      const cartCounterBorderWidth = pxToVw(cartCounterBorder.outerWidth()) - parentPadding * 2;
      gsap.set(cartCounterParent, { width: `${cartCounterBorderWidth}vw` });
    } else {
      $(this).text(count);
    }
  });
};

const renderCart = () => {
  const cartBtn = $('.nav-item-link[href$="#cart"]');
  const cartBtnText = cartBtn.find('.nav-item-link-text');
  const cartInformer = cartMenu.find('.cart-menu-informer');
  const cartSubtotalParent = cartMenu.find('.cart-subtotal-parent');
  const cartCounter = $('.nav-item-cart-counter');
  let savedCart = localStorage.getItem('cart');
  savedCart = savedCart ? JSON.parse(savedCart) : [];
  let html = '';
  let itemsCount = 0;
  let total_price = 0;
  savedCart.forEach((item, index) => {
    itemsCount += item.productQuantity;
    total_price += item.productPrice * item.productQuantity;
    html += `
          <div class="cart-menu-cart-product-parent" data-product-id="${item.productID}">
            <img class="cart-product-image" src="${item.productImage}">
            <div class="cart-product-info">
              <div class="cart-product-sub">
                <p class="cart-product-title font-primary-text-medium">${item.productTitle} device</p>
                <p class="cart-product-price font-primary-text-medium">${formatMoneyUSD(item.productPrice)}</p>
              </div>
              <div class="cart-product-sub">
                <div class="cart-quantity-parent">
                  <button type="button"
                    class="cart-quantity-changer quantity-minus"
                    data-line="${index + 1}"
                    ${item.productQuantity === 1 ? 'disabled' : ''}>
                    <img class="cart-quantity-icon" src="${quantityIcons.minus}">
                  </button>
                  <label class="cart-quantity-input font-primary-text-semibold">${item.productQuantity}</label>
                  <button type="button"
                    class="cart-quantity-changer quantity-plus"
                    data-line="${index + 1}">
                    <img class="cart-quantity-icon" src="${quantityIcons.plus}">
                  </button>
                </div>
                <button class="cart-remove-product" data-line="${index + 1}">
                  <p class="font-primary-text-regular">Remove</p>
                </button>
              </div>
            </div>
          </div>
        `;
  });

  if (itemsCount == 0) {
    html = `
            <h2 class="cart-empty-title font-headline3">It’s a bit empty in here</h2>
          `;
    checkoutBtn.find('.button-text').text('Continue shopping');
    checkoutBtn.attr('href', createPath('/products/activforce-2'));
    cartInformer.css('opacity', '0');
    cartSubtotalParent.css('opacity', '0');
  } else {
    checkoutBtn.find('.button-text').text('Checkout');
    checkoutBtn.attr('href', 'javascript:void(0)');
    cartInformer.css('opacity', '1');
    cartSubtotalParent.css('opacity', '1');
  }
  setCartNavCounter(itemsCount);
  $('.cart-menu-products-list').html(html);
  $('.cart-menu-title').text(`your cart (${itemsCount})`);
  $('.card-subtotal-price').text(formatMoneyUSD(total_price));
};

const cartInnerControl = () => {
  $(document).on('click', '.quantity-minus, .quantity-plus', function (event) {
    const productID = $(this).closest('.cart-menu-cart-product-parent').attr('data-product-id');
    let savedCart = localStorage.getItem('cart');
    savedCart = savedCart ? JSON.parse(savedCart) : [];
    const currentProduct = savedCart.find((item) => item.productID === productID);
    let changeValue = 0;

    if ($(event.target).closest('.quantity-minus').length) {
      changeValue = -1;
    } else if ($(event.target).closest('.quantity-plus').length) {
      changeValue = 1;
    }

    const updatedCart = savedCart.map((item) => {
      if (item.productID === productID) {
        return {
          ...item,
          productQuantity: Math.max(1, item.productQuantity + changeValue),
        };
      }
      return item;
    });

    localStorage.setItem('cart', JSON.stringify(updatedCart));
    renderCart();
  });
  $(document).on('click', '.cart-remove-product', function () {
    const productID = $(this).closest('.cart-menu-cart-product-parent').attr('data-product-id');
    let savedCart = localStorage.getItem('cart');
    savedCart = savedCart ? JSON.parse(savedCart) : [];
    savedCart = savedCart.filter((item) => item.productID !== productID);
    localStorage.setItem('cart', JSON.stringify(savedCart));
    renderCart();
  });
  checkoutBtn.on('click', function () {
    if ($(this).attr('href') == 'javascript:void(0)') {
      let savedCart = localStorage.getItem('cart');
      savedCart = savedCart ? JSON.parse(savedCart) : [];
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(() => {
          const updates = {};
          savedCart.forEach((item) => {
            updates[item.productID] = item.productQuantity;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
        })
        .then((res) => res.json())
        .then((data) => {
          window.location.href = '/checkout';
          //localStorage.setItem('cart', JSON.stringify([]));
        })
        .catch((err) => console.error(err));
    }
  });
};

const cartAnimation = () => {
  gsap.set(cartOverflow, {
    clearProps: 'all',
    display: 'block',
    visibility: 'hidden',
  });
  const cartNav = $('.nav-item-link[href$="#cart"]');
  const cartWidth = pxToVw(cartMenu.outerWidth());
  const cartHeight = isDesktop() || isTablet() ? pxToVw(cartMenu.outerHeight()) : pxToVh(cartMenu.outerHeight());
  const cartOverflowWidth = pxToVw(cartOverflow.outerWidth());
  const cartOverflowHeight = pxToVw(cartOverflow.outerHeight());
  const cartNavWidth = pxToVw(cartNav.outerWidth(true));
  const cartNavOffset = pxToVw(cartNav.offset().left);
  const cartOverflowOffset = 100 - cartWidth - 1.875;
  gsap.set(cartOverflow, {
    clearProps: 'all',
    display: 'none',
    visibility: 'visible',
  });
  const cartTL = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(cartCloseBG, { display: 'block' });
      cartMenu.attr('data-opened', 'true');
      isCartOpened = true;
    },
    onReverseComplete: () => {
      gsap.set(cartCloseBG, { display: 'none' });
      cartMenu.attr('data-opened', 'false');
      isCartOpened = false;
    },
  });
  cartTL.add(
    gsap.fromTo(
      cartOverflow,
      {
        y: isDesktop() ? '-1.25vw' : 0,
        left: isDesktop() ? `${cartNavOffset}vw` : 0,
        width: isDesktop() ? `${cartNavWidth}vw` : '100vw',
        height: '0vw',
      },
      {
        y: 0,
        left: () => (isDesktop() ? `${cartOverflowOffset}vw` : 0),
        width: `${cartWidth}vw`,
        height: `${cartHeight}${isDesktop() || isTablet() ? 'vw' : 'vh'}`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  cartTL.add(
    gsap.fromTo(
      cartCloseBtn,
      {
        x: `-5.313vw`,
        rotate: 0,
      },
      {
        x: 0,
        rotate: 180,
        duration: 1,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  cartTL.add(
    gsap.fromTo(
      cartLines,
      {
        scaleX: 0,
      },
      {
        scaleX: 1,
        duration: 1,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0.17
  );

  return cartTL;
};

const cartOpenControl = () => {
  const cartButton = header.find('.nav-item-link[href$="#cart"]');

  cartButton.on('click', () => {
    if (!isMenuOpened) {
      if (isCartOpened) {
        cartTL.reverse();
      } else if (isCartNotificationOpened && !isCartOpened) {
        renderCart();
        cartNotificationTL.reverse();
        gsap.delayedCall(1, () => cartTL.play());
      } else if (isNotificationOpened && !isCartOpened) {
        renderCart();
        notificationTL.reverse();
        gsap.delayedCall(1, () => cartTL.play());
      } else {
        renderCart();
        cartTL.play();
      }
      isCartOpened = !isCartOpened;
    }
  });
  cartCloseBtn.on('click', () => {
    cartTL.reverse();
    isCartOpened = false;
  });
};

const initCart = () => {
  let sumCount = 0;
  let savedCart = localStorage.getItem('cart');
  savedCart = savedCart ? JSON.parse(savedCart) : [];
  savedCart.forEach((item, index) => {
    sumCount += item.productQuantity;
  });

  addCartNavCounter();
  setCartNavCounter(sumCount);

  cartTL = cartAnimation();
  $(window).on('deviceChange', function () {
    setTimeout(function () {
      cartTL.kill();

      cartTL = cartAnimation();

      if (isCartOpened) {
        renderCart();
        cartTL.play();
      }
    }, 0);
  });

  cartInnerControl();
  cartOpenControl();

  cartCloseBG.on('click', function () {
    cartTL.reverse();
    isCartOpened = false;
  });
}

/*
$(window).on('load', function () {
  initCart();
});
*/

addSectionObserver(header, initCart);